import { render, staticRenderFns } from "./TeamReview_mobile.vue?vue&type=template&id=9a0ace9c&scoped=true"
import script from "./TeamReview_mobile.vue?vue&type=script&lang=js"
export * from "./TeamReview_mobile.vue?vue&type=script&lang=js"
import style0 from "./TeamReview_mobile.vue?vue&type=style&index=0&id=9a0ace9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0ace9c",
  null
  
)

export default component.exports